var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4578 2.00292C18.9691 1.52645 18.3889 1.14848 17.7503 0.890606C17.1117 0.63273 16.4272 0.5 15.7359 0.5C15.0446 0.5 14.3601 0.63273 13.7215 0.890606C13.0829 1.14848 12.5026 1.52645 12.0139 2.00292L10.9997 2.9913L9.98554 2.00292C8.99842 1.04094 7.6596 0.500499 6.26361 0.500499C4.86761 0.500499 3.52879 1.04094 2.54168 2.00292C1.55456 2.96491 1 4.26964 1 5.6301C1 6.99055 1.55456 8.29528 2.54168 9.25727L3.55588 10.2457L10.9997 17.5L18.4436 10.2457L19.4578 9.25727C19.9467 8.78102 20.3346 8.21557 20.5992 7.5932C20.8638 6.97084 21 6.30377 21 5.6301C21 4.95642 20.8638 4.28935 20.5992 3.66699C20.3346 3.04463 19.9467 2.47917 19.4578 2.00292Z",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/HeartIcon.3a0e19b76f916f19ab20040167ec5abb.svg";
export { ForwardRef as ReactComponent };